<div class="modal-buscar-talhoes">

  <app-select-padrao imgSrc="assets/mapa/filtros/fazenda.png"
    [label]="'COMPONENTS.MAPA.SEARCH_FIELD.farm_label' | transloco"
    [width]="20"
    [dadosSelect]="dadosSelect"
    (eventoSelect)="aplicarFiltroFazenda($event)"
  ></app-select-padrao>

  <div class="container-filtro mt-2">
    <input class="filtro-pesquisa color-input" (input)="filtrarTalhoes($event)" [placeholder]="'COMPONENTS.MAPA.SEARCH_FIELD.placeholder' | transloco" />
    <object class="icone-lupa" data="assets/icones-filtros/icone-lupa.svg" type="image/svg+xml">Lupa</object>
  </div>

  <app-loading *ngIf="loading" [linhas]="3" [colunas]="1" [height]="4.5"></app-loading>

  <ul *ngIf=" !loading && talhoesFiltrados && talhoesFiltrados.length !== 0; else naoTemTalhoes" class="h-100 d-flex flex-column gap-2" style="margin-top: 1rem">
    <li *ngFor="let talhao of talhoesFiltrados; let i = index">
      <button class="btn btn-light informacoes-talhao" [class.talhao-ativo]="i === talhaoSelecionadoIndex" (click)="atualizarTalhaoSelecionado(talhao, i)">
        <div class="w-100">
          <div class="d-flex align-items-center justify-content-between">
            <div class="img-texto">
              <img class="img-talhao" src="assets/mapa/filtros/map-marker.svg" alt="talhão"/>
              <h6>{{ talhao.vc_nome }}</h6>
            </div>
          </div>
        </div>
      </button>
    </li>
  </ul>

  <ng-template #naoTemTalhoes>
    <div *ngIf="!loading" class="d-flex align-items-center flex-column cor-cinza">
      <span> {{ "COMPONENTS.MAPA.SEARCH_FIELD.no_field_available" | transloco }} </span>
      <span> {{ "COMPONENTS.MAPA.SEARCH_FIELD.select_farm" | transloco }} </span>
    </div>
  </ng-template>
</div>
